<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-02-03 10:50:09
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-02-03 11:32:12
-->
<template>
  <div class="List">
    <div
      class="list_entrance"
      @click="goMyload"
    >
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/shenqingjilu.png"
            alt=""
          />
        </span>
        <span class="list_text">申请记录</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance"
      @click="goRealNameAuth"
    >
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/shiming.png"
            alt=""
          />
        </span>
        <span class="list_text">实名认证</span>
      </div>
      <div>
        <span class="auth_status">{{ authStatus ? '已认证' : '未认证' }}</span>
        <span class="icon">
          <van-icon name="arrow" />
        </span>
      </div>
    </div>
    <div
      class="list_entrance_nomargin"
      @click="goBindEnterprise"
    >
      <div class="line"></div>
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/bangding.png"
            alt=""
          />
        </span>
        <span class="list_text">企业管理</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance"
      @click="onUpload"
    >
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <van-icon
            name="upgrade"
            class="iconUpgrade"
          />
        </span>
        <span class="list_text">发票上传</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance"
      @click="goMyContract"
      style="margin-top: 0"
    >
      <div class="line"></div>
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/mycorat.png"
            alt=""
          />
        </span>
        <span class="list_text">我的合同</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance"
      @click="goAccountManage"
    >
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/accountManage.png"
            alt=""
          />
        </span>
        <span class="list_text">账号与安全</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <!-- <div
      class="list_entrance"
      @click="goResetPassword"
    >
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/chongzhi.png"
            alt=""
          />
        </span>
        <span class="list_text">密码重置</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance_nomargin"
      @click="destroyAccount"
    >
      <div class="line"></div>
      <div class="list_entrance_left">
        <span class="list_entrance_icon" style="margin-left: -1px;">
          <van-icon color="#fe663a" size="22" name="delete-o" />
        </span>
        <span class="list_text">注销账号</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div> -->
    <div
      class="list_entrance_nomargin"
      @click="privacyAgreement"
    >
      <div class="line"></div>
      <div class="list_entrance_left">
        <span class="list_entrance_icon" style="margin-left: -1px;">
          <van-icon color="#68befe" size="22" name="notes-o" />
        </span>
        <span class="list_text">隐私协议</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <div
      class="list_entrance_nomargin"
      @click="goLogOut"
    >
      <div class="line"></div>
      <div class="list_entrance_left">
        <span class="list_entrance_icon">
          <img
            src="@/assets/images/out.png"
            alt=""
          />
        </span>
        <span class="list_text">退出登录</span>
      </div>
      <span class="icon">
        <van-icon name="arrow" />
      </span>
    </div>
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
      <component
        :is="contract"
        :hidePopup="hidePopup"
      ></component>
    </van-popup>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Privacypolicy from '@/components/FeildTwo/components/Privacypolicy.vue';

export default {
  name: 'List',
  data() {
    return {
      show: false,
      contract: 'Privacypolicy',

    };
  },
  props: ['authStatus', 'phone'],
  components: {
    Privacypolicy,
  },
  mounted() { },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    onUpload() {
      window.location.href = '/supermarket/v2/uploadTicket';
    },
    goMyload() {
      this.$router.push('/supermarket/v2/myload');
    },
    goRealNameAuth() {
      if (this.authStatus) {
        this.$router.push('/supermarket/v2/realNameAuth');
      } else {
        localStorage.setItem('returnPage', '/supermarket/v2/personalCenter');
        this.$router.push('/supermarket/v2/realName');
      }
    },
    goMyContract() {
      this.$router.push('/supermarket/v2/myContract');
    },
    goBindEnterprise() {
      if (this.authStatus) {
        this.$router.push('/supermarket/v2/bindEnterprise');
      } else {
        this.$toast({
          message: '请您先完成实名认证',
          duration: 3500,
        });
      }
    },
    goResetPassword() {
      this.$router.push({
        path: '/supermarket/v2/resetPassword',
        query: {
          phone: encodeURIComponent(this.phone),
        },
      });
    },
    goAccountManage() {
      this.$router.push({
        path: '/supermarket/v2/accountManage',
        query: {
          phone: encodeURIComponent(this.phone),
        },
      });
    },
    goLogOut() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否退出登录',
        })
        .then(() => {
          // on confirm
          this.rightNext('logout');
        })
        .catch(() => {
          // on cancel
        });
    },
    destroyAccount() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '您正在注销个人账号，该操作不可恢复。注销后将清空账号信息，请确保所有交易已完结且无纠纷。账号注销后因历史交易可能产生的相关权益视作自动放弃',
        })
        .then(() => {
          this.rightNext('destroyAccount');
        })
        .catch(() => {
          // on cancel
        });
    },
    privacyAgreement() {
      this.show = true;
    },
    hidePopup() {
      this.show = false;
    },
    rightNext(key) {
      this.$api.PublicPage[key]()
        .then((res) => {
          this.Isclose = false;
          if (res.success) {
            if (key === 'destroyAccount') {
              this.$toast(
                {
                  message: '账号注销完成',
                  clear: true,
                  forbidClick: true,
                  duration: 2200,
                },
              );
              setTimeout(() => {
                localStorage.removeItem('name');
                localStorage.removeItem('loanPeoplePhone');
                localStorage.setItem('redirect', '/supermarket/v2/');
                this.$router.push('/supermarket/v2/login');
              }, 2000);
              return;
            }
            localStorage.removeItem('name');
            localStorage.removeItem('loanPeoplePhone');
            localStorage.setItem('redirect', '/supermarket/v2/');
            this.$router.push('/supermarket/v2/login');
          } else {
            this.$toast.fail(res.returnMessage);
          }
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
.list_entrance {
  height: 20px;
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin: 8px 0px 0 0px;
  position: relative;
}
.list_entrance_nomargin {
  height: 20px;
  background: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0, 31, 51, 0.08);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  margin: 0px;
  position: relative;
}
.icon {
  font-size: 18px;
  color: #80848f;
}
.list_text {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #1c2438;
}
.list_entrance_left {
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.list_entrance_icon {
  margin-top: 4px;
  margin-right: 12px;
}
.list_entrance_icon img {
  width: 20px;
}
.iconUpgrade {
  width: 22px;
  font-size: 24px;
  margin-left: -2px;
  color: #67b7ff;
  margin-top: 3px;
}
.auth_status {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  letter-spacing: 0;
  margin-right: 10px;
}
.line {
  position: absolute;
  top: 0;
  right: 0;
  width: 88%;
  height: 1px;
  background: #efeff1;
  margin: 0 auto;
}
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}
</style>
